import {
  consumerResponsesConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { consumerResponsesService } from "../../services";
import { success, withSpinner } from "../../../../redux/actions/utilities";

const { CUSTOMER_RESPONSE_DATA, GET_ORDER_DETAIL } = consumerResponsesConstants;

//Gett user responses detail by customerId
const getUserResponseByCustomerId = (customerId, externalId, body) => {
  return (dispatch) => {
    withSpinner(dispatch, CUSTOMER_RESPONSE_DATA, () =>
      consumerResponsesService
        .getUserResponseByCustomerId(customerId, externalId, body)
        .then(
          (response) => {
            dispatch(success(response, CUSTOMER_RESPONSE_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Get Order Detail by order id
const getOrderDetailByOrderId = (orderId) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_ORDER_DETAIL, () =>
      consumerResponsesService
        .getOrderDetailByOrderId(orderId)
        .then(
          (response) => {
            dispatch(success(response, GET_ORDER_DETAIL));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

export const consumerResponsesActions = {
  getUserResponseByCustomerId,
  getOrderDetailByOrderId,
};
